type FieldErrorsMap = Record<string, Partial<Record<string, string[] | undefined>> | undefined>;

export const hasAnyFieldError = (errors?: FieldErrorsMap): boolean =>
  Object.values(errors || {}).some((byField) =>
    Object.values(byField || {}).some((messages) => (messages?.length ?? 0) > 0)
  );
